import * as assetsHelpers from '../../../helpers/assets';
import Logger from '../../../services/Logger';
import localization from '../../../shared/strings';
import * as utils from '../../../shared/utils';
import Toast from '../../../components/Toast';
import TYPES from '../../action-types';
import picsioConfig from '../../../../../../config';
import checkMultipleChanges from './checkMultipleChanges';
import { reloadCurrentPage } from '../../../helpers/history';
import checkSelectedAssetsPermission from '../../helpers/assets/checkSelectedAssetsPermission';
import showForbiddenDialog from './showForbiddenDialog';

/**
 * Change description on assets
 * @param {string[]} ids
 * @param {string} description
 * @param {Function} onCancel
 */
const changeDescription = (ids, description, onCancel) => async (dispatch, getAll) => {
  const selectedItems = ids || getAll().assets.selectedItems;
  dispatch({ type: TYPES.ASSETS.CHANGE_DESCRIPTION.START });

  if (picsioConfig.isMainApp) {
    const isEditAssetKeywordsAllowed = await checkSelectedAssetsPermission({
      selectedItems,
      permissionName: 'editAssetDescription',
    });
    if (!isEditAssetKeywordsAllowed) {
      showForbiddenDialog(localization.DIALOGS.WARNING_EDIT_ASSET_KEYWORDS.TEXT);
      dispatch({ type: TYPES.ASSETS.CHANGE_DESCRIPTION.STOPPED });
      return;
    }
  }
  checkMultipleChanges(ids.length, doChange, onCancel);

  async function doChange() {
    try {
      const { data } = await assetsHelpers.setDescription(ids, description);

      if (data.hasNotPermittedAssets) {
        Toast(localization.NO_COLLECTION_PERMISSION_TO_ACCESS('change description'), { autoClose: false });
      }

      dispatch({
        type: TYPES.ASSETS.CHANGE_DESCRIPTION.COMPLETE,
        payload: { ids, description, userId: getAll().user._id },
      });
    } catch (error) {
      const errorStatus = utils.getStatusFromResponceError(error);
      const errorMessage = errorStatus === 403
        ? localization.NO_PERMISSION_TO_ACCESS
        : localization.DETAILS.textCantUpdate('description');
      Toast(errorMessage, {
        autoClose: false, type: 'error', onOk: reloadCurrentPage, btnOkValue: localization.HISTORY.textBtnRefresh,
      });
      dispatch({ type: TYPES.ASSETS.CHANGE_DESCRIPTION.FAILED, error });
      Logger.error(new Error('Error change description'), { error }, [
        'ChangeDescriptionFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);
    }
  }
};

export default changeDescription;
